// Libs
import React, { Component } from 'react'

// Components
import Button from '@react-mdc/button'

export type Props = {
  onClickSubmit: ?Function,
  onClickCancel: ?Function,
  style: Object,
}

// Styles
const styles = {
  submitBtn: {
    marginRight: 15,
  },
}

export default class SubmitCancel extends Component {
  props: Props

  render(): ?React.Element<any> {
    return (
      <div style={this.props.style}>
        <Button raised primary onClick={this.props.onClickSubmit} style={styles.submitBtn}>
          {'Submit'}
        </Button>
        <Button raised primary onClick={this.props.onClickCancel}>
          {'Cancel'}
        </Button>
      </div>
    )
  }
}
